import { render, staticRenderFns } from "./Bluetooth.vue?vue&type=template&id=f1f5ad10&scoped=true&"
import script from "./Bluetooth.vue?vue&type=script&lang=js&"
export * from "./Bluetooth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f5ad10",
  null
  
)

export default component.exports